export default __webpack_public_path__ + "static/media/Icon awesome-puzzle-piece.5dd56942.svg";